<template>
  <div class="d-flex align-center py-2 nomination-radio-row">
    <div class="d-flex flex-grow-1 nomination-radio-cells">
      <v-card
        v-for="def in nominationDefs"
        :key="def.id"
        :outlined="selectedVendibleId !== def.id"
        :color="selectedVendibleId === def.id ? 'primary' : ''"
        :dark="selectedVendibleId === def.id"
        class="nomination-card flex-grow-1"
        @click="handleToggle(def.id)"
      >
        <v-card-text
          :class="[
            'pa-3 text-center font-weight-medium',
            selectedVendibleId === def.id ? 'white--text' : '',
          ]"
        >
          {{ def.name }}
        </v-card-text>
      </v-card>
    </div>

    <div class="cast-name text-body-1 ml-3">
      {{ cast.name || `cast#${cast.id}` }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NominationRadioRow',
  props: {
    cast: { type: Object, required: true },
    nominationDefs: { type: Array, required: true },
    selectedVendibleId: { type: [Number, String], default: null },
  },
  emits: ['change'],
  setup(props, { emit }) {
    // 選択中のカードを再度タップすると解除
    const handleToggle = vendibleId => {
      const next = props.selectedVendibleId === vendibleId ? null : vendibleId
      const def = next ? (props.nominationDefs.find(d => d.id === next) || null) : null
      emit('change', { vendibleId: next, def })
    }

    return { handleToggle }
  },
}
</script>

<style scoped>
.nomination-radio-row {
  border-bottom: 1px solid rgba(127, 127, 127, 0.12);
}
.nomination-radio-cells {
  display: flex;
  gap: 8px;
}
.nomination-card {
  cursor: pointer;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
